import { Spinner } from '@consigli/facade';
import {
  useBuildingPackageId,
  useLazyGetBuildingPackageBuildingJsonQuery,
  useProjectId,
  useGetBuildingPackageQuery,
} from '@consigli/hooks';
import { Button } from '@consigli/shadcn';
import { saveJson } from '@consigli/utils';
import { useCallback, useState } from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';

export const DownloadBuildingJsonButton = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();
  const [isDownloading, setIsDownloading] = useState(false);

  const { data: buildingPackage } = useGetBuildingPackageQuery({
    projectId,
    buildingPackageId,
  });
  const [getBuildingJSON] = useLazyGetBuildingPackageBuildingJsonQuery();

  const downloadJSON = useCallback(async () => {
    setIsDownloading(true);
    try {
      const buildingJSON = await getBuildingJSON({ projectId, buildingPackageId }).unwrap();
      if (buildingJSON) {
        const fileName = buildingPackage?.name
          ? `${buildingPackage.name}.json`
          : 'building-package.json';
        saveJson(fileName, buildingJSON);
      } else {
        console.error('Failed to download JSON: buildingJSON is null');
      }
    } catch (error) {
      console.error('Failed to download JSON:', error);
    } finally {
      setIsDownloading(false);
    }
  }, [buildingPackageId, getBuildingJSON, projectId, buildingPackage?.name]);

  return (
    <Button variant="outline" onClick={downloadJSON} disabled={isDownloading}>
      {isDownloading ? <Spinner size="xsmall" /> : <MdOutlineFileDownload className="size-5" />}
      Download JSON
    </Button>
  );
};
